import { render, staticRenderFns } from "./WebPartFormSubmitRunner.vue?vue&type=template&id=0bff73bc&"
import script from "./WebPartFormSubmitRunner.vue?vue&type=script&lang=js&"
export * from "./WebPartFormSubmitRunner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports